// Name             ==> Name of the current Popop that is opened
// isOpenAudit      ==> to open and Close Audit Modal

import { useState } from "react";
import ProviderSched from '../Account/Provider/ProviderSchedModal'
import LocationProvider from "../Account/Location/LocationScheduler";
import { useSelector } from "react-redux";

// DeletePopup      ==> Delete Confirmation Popup
const ModalHeader = (props) => {
  const { HeaderName, isOpenAudit, handleAuditModal, DeletePopup, handleDeleteModal, Key, Name, isClosed, providerID, TaskPopup, LocationID, LocationName, HideAuditIcon, IsDeleteAllowed,conditionalLabel } =
    { ...props };
  let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
  let ADC = DropDowns?.IsAdultDayCare
  let Homecare = DropDowns?.IsHomeCare
  const [isActive, setisActive] = useState(false);
  const [modal, setModal] = useState(false)
  const [locationModal, setLocationModal] = useState(false)


  const open = () => {
    setModal(true)
  }
  const close = () => {
    setModal(false)
  }
  const openLocation = () => {
    setLocationModal(true)

  }
  const closeLocation = () => {
    setLocationModal(false)
  }

  let provider = "";
  if (modal) {
    provider = <ProviderSched isopenProviderSch={modal} isClosed={close} providerID={providerID} Name={Name} conditionalLabel={conditionalLabel} />
  }
  let Location = "";
  if (locationModal) {
    Location = <LocationProvider isopenLocationSch={locationModal} isClosed={closeLocation} LocationID={LocationID} LocationName={LocationName} />
  }
  return (


    <div className="d-flex justify-content-between align-items-center mt-2 mb-10 hk-modal-header">
      {provider}
      {Location}
      {HeaderName()}
      <div>
        {DeletePopup === "" ?
          <> </> : <>
            <button className="btn-icon-transparent" onClick={() => setisActive(!isActive)}>
              <div className="app_tooltip bottom">
                <i className="icon-dots-menu"></i>
                <p class="tool_tip xsm_text text-light">Options</p>
              </div>
            </button></>}

        {ADC === 'true' || Homecare === 'true' ? null :

          <>
            {Name === 'Provider' ?
              DeletePopup === "" ? <></> :
                <button className="btn-icon-transparent" onClick={open} >
                  <div className="app_tooltip left">
                    <i className="icon-file-timer"></i>
                    <p class="tool_tip xsm_text text-light">Provider Schedule</p>
                  </div>
                </button>
              : null}
          </>

        }
        {ADC === 'true' || Homecare === 'true' ? null :

          <>
            {LocationName === 'Location' ?
              DeletePopup === "" ? <></> :
                <button className="btn-icon-transparent" onClick={openLocation} >
                  <div className="app_tooltip left">
                    <i className="icon-file-timer"></i>
                    <p class="tool_tip xsm_text text-light">Location Schedule</p>
                  </div>
                </button>
              : null}
          </>}

        {/* {Name === 'Guarantor' ? <button className="btn-icon-transparent" onClick={() => handleDeleteModal()}>
          <i className="icon-delete"></i></button> : null} */}
        {isClosed ? <button className="btn-icon-transparent" onClick={isClosed}>
          <i className="icon-x-cros fs-20 fs-20 dark-clr"></i>
        </button> : <></>}

        <div className={`hk-submenu ${isActive && 'active'}`}>
          <ul>
            {["Task", "PatEncounter"].includes(HideAuditIcon) ? null : <li>
              <button
                aria-describedby={
                  Boolean(isOpenAudit) ? "simple-popper" : undefined
                }
                type="button"
                className="btn-icon-transparent"
                onClick={() => { handleAuditModal(); setisActive(!isActive); }}
              >
                <span className="icon">
                  <span className="icon-menu-1">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                    <span className="path4"></span>
                    <span className="path5"></span>
                    <span className="path6"></span>
                    <span className="path7"></span>
                    <span className="path8"></span>
                    <span className="path9"></span>
                    <span className="path10"></span>
                  </span>
                </span>
                <span className="title">Audit</span>
              </button>
            </li>}

            <li>
              {handleDeleteModal ?
                <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={() => { handleDeleteModal(); setisActive(!isActive); }}>
                  <span className="icon">
                    <i className="icon-delete"> </i>
                  </span>
                  <span className="title">Delete</span>
                </button>
                : DeletePopup}
            </li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default ModalHeader;
